"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _requestSeatUpgrade = require("ui-addon-upgrades/_core/upgrade/requestSeatUpgrade");

var _requestAdditionalSeats = require("ui-addon-upgrades/_core/upgrade/requestAdditionalSeats");

var _requestSKU = require("ui-addon-upgrades/_core/upgrade/requestSKU");

var _requestTrial = require("ui-addon-upgrades/_core/upgrade/requestTrial");

var _requestRemoteTools = require("ui-addon-upgrades/_core/upgrade/requestRemoteTools");

var _requestQuotePurchase = require("ui-addon-upgrades/_core/upgrade/requestQuotePurchase");

var AdminModalTypes = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/constants/AdminModalTypes"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _MerchandiseIdsToUpgradeProducts = require("self-service-api/constants/MerchandiseIdsToUpgradeProducts");

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var _REQUEST_FUNCTION_BY_;

var REQUEST_FUNCTION_BY_TYPE = (_REQUEST_FUNCTION_BY_ = {}, (0, _defineProperty2.default)(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_ADDITIONAL_SEATS, _requestAdditionalSeats.requestAdditionalSeats), (0, _defineProperty2.default)(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_SEAT_UPGRADE, _requestSeatUpgrade.requestSeatUpgrade), (0, _defineProperty2.default)(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_SEAT_UPGRADE_BANNER, _requestSeatUpgrade.requestSeatUpgrade), (0, _defineProperty2.default)(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_SKU, _requestSKU.requestSKU), (0, _defineProperty2.default)(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_TRIAL, _requestTrial.requestTrial), (0, _defineProperty2.default)(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_QUOTE, _requestQuotePurchase.requestQuotePurchase), (0, _defineProperty2.default)(_REQUEST_FUNCTION_BY_, AdminModalTypes.REQUEST_REMOTE_TOOLS, _requestRemoteTools.requestRemoteTools), _REQUEST_FUNCTION_BY_);

var getHubType = function getHubType(merchandiseId) {
  var upgradeProduct = _MerchandiseIdsToUpgradeProducts.MerchandiseIdsToUpgradeProducts[merchandiseId];
  return upgradeProduct.split('-')[0].toUpperCase();
};

var AdminModal =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AdminModal, _Component);

  function AdminModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AdminModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AdminModal).call(this, props));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AdminModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      tracker.track('viewUpgradeAdminPrompt');
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          merchandiseId = _this$props.merchandiseId,
          modalType = _this$props.modalType,
          onClose = _this$props.onClose;
      var requestFunction = modalType === AdminModalTypes.REQUEST_QUOTE ? function () {
        return (0, _requestQuotePurchase.requestQuotePurchase)({
          hub: getHubType(merchandiseId)
        });
      } : function () {
        return REQUEST_FUNCTION_BY_TYPE[modalType]({
          merchandiseId: merchandiseId
        });
      };

      if (requestFunction) {
        requestFunction().then(function () {
          return _FloatingAlertStore.default.addAlert({
            message: _I18n.default.text('upgrades.adminModal.alertNotification.success.message'),
            titleText: _I18n.default.text('upgrades.adminModal.alertNotification.success.titleText'),
            type: 'success'
          });
        }).catch(function () {
          return _FloatingAlertStore.default.addAlert({
            message: _I18n.default.text('upgrades.adminModal.alertNotification.error.message'),
            titleText: _I18n.default.text('upgrades.adminModal.alertNotification.error.titleText'),
            type: 'danger'
          });
        });
      }

      onClose();
    }
  }, {
    key: "getProductName",
    value: function getProductName() {
      var merchandiseId = this.props.merchandiseId;
      var productProperties = _ImmutableMerchandiseIdMap.default[merchandiseId];

      var defaultName = _I18n.default.text('upgrades.products.default');

      return productProperties && productProperties.productName ? productProperties.productName : defaultName;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          modalType = _this$props2.modalType,
          onClose = _this$props2.onClose;
      return _react.default.createElement(_UIModal.default, {
        size: "auto",
        width: 540,
        use: "success",
        "data-selenium": "admin-only-modal"
      }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: onClose
      }), _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.adminModal." + modalType + ".title"
      }))), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement("p", {
        className: "p-right-4"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.adminModal." + modalType + ".paragraph",
        options: {
          productName: this.getProductName()
        }
      }))), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement("div", {
        "data-selenium": "admin-modal-close-button"
      }, _react.default.createElement(_UIButton.default, {
        className: "m-left-0",
        use: "primary",
        onClick: this.handleClick
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.adminModal." + modalType + ".button"
      })))));
    }
  }]);
  return AdminModal;
}(_react.Component);

AdminModal.propTypes = {
  merchandiseId: _propTypes.default.number,
  modalType: _propTypes.default.oneOf(Object.values(AdminModalTypes || {})),
  onClose: _propTypes.default.func.isRequired
};
var _default = AdminModal;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/components/AdminModal.js
// module id = 731
// module chunks = 5 6